import React from "react";
import styled from "styled-components";

import BlankState from "../../Common/BlankState";

import variables from "../../../constants/assets/variables";
import { FlexContainer } from "../../../constants/assets/containers";

import { isValNull } from "../../../utils";
import { useHistory } from "react-router-dom/";
import { BANNER_STATUS_MAP } from "../constants";

const BannersList = (props) => {
  const { driverBannerList } = props;
  const history = useHistory();
  const handleBannerClick = (bannerId, action) => {
    history.push(`/banner/details?id=${bannerId}&action=${action}`);
  };

  const handleTargetAudienceClick = (bannerId, action) => {
    history.push(`/banner/target_audience?id=${bannerId}&action=${action}`);
  };

  const getDriverBannerDetail = (bannerData, index) => {
    return (
      <BannerCardContainer key={index}>
        <BannerCardLeft>
          <img width={150} src={bannerData?.media?.[0]?.url} alt="banner" />
        </BannerCardLeft>
        <BannerCardRight>
          <BannerInfo>
            <h3>ID: {bannerData.banner_id}</h3>
            <span>Name: {bannerData.name}</span>
            <span>Start Time : {bannerData?.start_time}</span>
            <span>End Time : {bannerData?.expiry_time}</span>

            <span
              style={{
                display: "flex",
                alignItems: "center",
                gap: "4px",
              }}
            >
              Status :{" "}
              <StatusChip status={bannerData.banner_status}>
                {BANNER_STATUS_MAP?.[bannerData.banner_status]}
              </StatusChip>
            </span>
          </BannerInfo>
          <BannerActions>
            <ActionButton
              onClick={() => handleTargetAudienceClick(bannerData.banner_id, "create")}
            >
              Target Audience
            </ActionButton>
            <VerticalSeparator />
            <ActionButton
              onClick={() => handleBannerClick(bannerData.banner_id, "edit")}
            >
              Edit
            </ActionButton>
            <VerticalSeparator />
            <ActionButton
              onClick={() => handleBannerClick(bannerData.banner_id, "view")}
            >
              View
            </ActionButton>
          </BannerActions>
        </BannerCardRight>
      </BannerCardContainer>
    );
  };

  return (
    <BannerListContainer>
      {!isValNull(driverBannerList) ? (
        driverBannerList.map((bannerData, index) => {
          return getDriverBannerDetail(bannerData, index);
        })
      ) : (
        <BlankSlateWrapper>
          <BlankState />
        </BlankSlateWrapper>
      )}
    </BannerListContainer>
  );
};

const BannerListContainer = styled(FlexContainer)`
  flex-wrap: wrap;
  border-radius: ${variables.borderRadius};
  background-color: white;
  align-items: center;
`;

const BlankSlateWrapper = styled.div`
  width: 100%;
  margin: auto;
`;

const BannerCardContainer = styled.div`
  width: 100%;
  padding: 16px;
  gap: 4px;
  display: flex;
  border-bottom: 1px solid ${variables.borderColor};
  &:last-child {
    border-bottom: none;
  }
`;

const BannerCardLeft = styled.div`
  width: 20%;
`;

const BannerCardRight = styled.div`
  width: 80%;
  padding: 0 12px;
  display: flex;
  justify-content: space-between;
`;

const BannerInfo = styled.div`
  display: flex;
  gap: 8px;
  flex-direction: column;
  h3 {
    margin: 0;
    padding: 0;
    font-weight: 400;
  }

  span {
    font-size: 14px;
  }

  a {
    color: ${variables.primaryColor};
    text-decoration: none;
  }
`;

const BannerActions = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 16px;
`;

const ActionButton = styled.div`
  color: ${variables.primaryColor};
  border: none;
  cursor: pointer;
`;

const VerticalSeparator = styled.div`
  width: 1px;
  height: 20px;
  background-color: ${variables.borderColor};
`;

const StatusChip = styled.span`
  padding: 2px 8px;
  border-radius: 4px;
  font-size: 12px !important;
  background-color: ${(props) =>
    props.status === "BANNER_STATUS_ACTIVE" ? "green" : "red"};
  color: white;
`;

export default BannersList;
